import React from 'react';
import { Check } from 'lucide-react';

/**
 * SUB-COMPONENT: INDIVIDUAL PRICE CARD
 */
const PricingCard = ({ plan }) => {
    const {
        tag,
        title,
        price,
        duration,
        features,
        isHighlighted
    } = plan;

    return (
        <div className={`relative flex flex-col p-8 rounded-3xl border transition-all duration-300 ${isHighlighted
            ? "border-blue-500 shadow-xl shadow-blue-50 bg-white scale-105 z-10"
            : "border-gray-200 bg-white hover:border-blue-200"
            }`}>

            {/* Top Tag/Badge */}
            {tag && (
                <div className="mb-4">
                    <span className={`px-3 py-1 rounded-full text-xs font-bold border ${isHighlighted
                        ? "bg-blue-50 text-blue-600 border-blue-200"
                        : "bg-gray-50 text-gray-500 border-gray-200"
                        }`}>
                        {tag}
                    </span>
                </div>
            )}

            {/* Plan Details */}
            <h3 className="text-xl font-bold text-[#1A2B3C] mb-4 h-14">
                {title}
            </h3>

            <div className="mb-6">
                <div className="flex items-baseline gap-1">
                    <span className="text-4xl font-black text-[#1A2B3C]">₹{price}</span>
                    <span className="text-gray-400 text-sm">/{duration} + GST</span>
                </div>
            </div>

            <button className={`w-full py-3 rounded-xl font-bold mb-8 transition-colors ${isHighlighted
                ? "bg-[#0F172A] text-white hover:bg-black"
                : "bg-[#0F172A] text-white hover:bg-black"
                }`}>
                Start Registration
            </button>

            {/* Features List */}
            <div className="space-y-4 flex-grow">
                {features.map((feature, index) => (
                    <div key={index} className="flex items-start gap-3 group">
                        <Check size={16} className="text-green-500 mt-1 flex-shrink-0" />
                        <span className="text-gray-600 text-sm leading-tight group-hover:text-gray-900 transition-colors">
                            {feature}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};

/**
 * MAIN COMPONENT: SECTION WRAPPER
 */
const PricingSection = ({ title, subtitle, plans }) => {
    return (
        <section className="bg-[#F8FAFC] py-24 px-6">
            <div className="max-w-7xl mx-auto">
                {/* Header */}
                <div className="text-center mb-16 space-y-4">
                    <h2 className="text-4xl font-bold text-[#1A2B3C]">{title}</h2>
                    <p className="text-gray-500 text-lg">{subtitle}</p>
                </div>

                {/* Pricing Grid */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-stretch">
                    {plans.map((plan, index) => (
                        <PricingCard key={index} plan={plan} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default PricingSection;